import React, { useState } from "react";
import SurveyConfirmationModal from "../components/SurveyConfirmationModal";
import { moveItem } from "../domain/survey.formatters";
import { newQuestion } from "../domain/survey.factories";
import SurveyMobilePreview from "../preview/SurveyMobilePreview";
import QuestionNavigator from "./QuestionNavigator";
import SurveyConfiguration from "./SurveyConfiguration";
import SurveyDetailsForm from "./SurveyDetailsForm";
import SurveyQuestionEditor from "./SurveyQuestionEditor";

const SurveyBuilderWorkspace = ({ form, errors, readOnly, selectedQuestionId, onSelect, onChange }) => {
  const [pendingRemovalIndex, setPendingRemovalIndex] = useState(null);
  const questions = form.questions || [];
  const selectedIndex = questions.findIndex((question) => question.id === selectedQuestionId);
  const selectedQuestion = selectedIndex >= 0 ? questions[selectedIndex] : null;
  const changeQuestions = (nextQuestions) => onChange({ ...form, questions: nextQuestions });
  const addQuestion = (type) => {
    const question = newQuestion(type, questions);
    changeQuestions([...questions, question]);
    onSelect(question.id);
  };
  const confirmQuestionRemoval = () => {
    if (pendingRemovalIndex === null) return;
    const nextQuestions = questions.filter((question, index) => index !== pendingRemovalIndex);
    changeQuestions(nextQuestions);
    const fallback = nextQuestions[Math.min(pendingRemovalIndex, nextQuestions.length - 1)];
    onSelect(fallback ? fallback.id : null);
    setPendingRemovalIndex(null);
  };

  return <div className="survey-builder-tab-content">
    <SurveyConfiguration form={form} errors={errors} readOnly={readOnly} onChange={onChange} />
    <SurveyDetailsForm form={form} errors={errors} readOnly={readOnly} onChange={onChange} />
    <div className="survey-builder-workspace">
      <section className="survey-builder-editor">
        <div className="survey-builder-panel-heading"><div><strong>Question builder</strong><span>Select a question to edit</span></div></div>
        <QuestionNavigator questions={questions} errors={errors} selectedQuestionId={selectedQuestionId} readOnly={readOnly} onSelect={onSelect} onMove={(index, target) => changeQuestions(moveItem(questions, index, target))} onRemove={setPendingRemovalIndex} onAdd={addQuestion} />
        <div className="survey-builder-settings">
          {!selectedQuestion ? <div className="survey-builder-empty-question-settings"><i className="fa fa-list-alt" /><strong>No question selected</strong><span>Select an existing question or add a new one.</span></div> : <SurveyQuestionEditor question={selectedQuestion} index={selectedIndex} errors={(errors.questions && errors.questions[selectedIndex]) || {}} readOnly={readOnly} inspector onChange={(nextQuestion) => { const next = questions.slice(); next[selectedIndex] = nextQuestion; changeQuestions(next); }} />}
        </div>
      </section>
      <SurveyMobilePreview form={form} selectedQuestionId={selectedQuestionId} questionOnly />
    </div>
    <SurveyConfirmationModal show={pendingRemovalIndex !== null} title="Remove Question?" message="Remove this question? This change will be applied when the survey draft is saved." confirmLabel="Remove Question" confirmStyle="danger" onCancel={() => setPendingRemovalIndex(null)} onConfirm={confirmQuestionRemoval} />
  </div>;
};

export default SurveyBuilderWorkspace;
